export default __webpack_public_path__ + "static/media/aerztefon_logo_claim.d8cc6f0e.png";